export default "__VITE_ASSET__CJi0u70w__"